import React from 'react';
import moment from 'moment';
import classnames from 'classnames';

import { InputLabel } from 'components/common/form';
import DatePicker from 'components/common/datepicker/DatePicker';
import { REACT_DATEPICKER_DATE_FORMAT } from 'constants/appConstants';
import type { DateInput } from 'interface/common';

interface DateChangePayload {
  target: {
    name: string;
    value: string;
  };
}

interface DateSelectorProps {
  label: string;
  name: string;
  isMandatory?: boolean;
  placeholderText: string;
  value?: DateInput;
  error?: string | false;
  handleChange: (payload: DateChangePayload) => void;
  disabled?: boolean;
  showMonthDropdown?: boolean;
  showYearDropdown?: boolean;
}

const DateSelector: React.FC<DateSelectorProps> = (props) => {
  const { label, name, isMandatory, placeholderText, value, error, handleChange, disabled, ...rest } = props;

  const handleOnChange = (selectedDate: Date) =>
    handleChange({
      target: {
        name: name,
        value: moment(selectedDate).format('YYYY-MM-DD'),
      },
    });

  return (
    <div className="form-group" key={label + '-input'}>
      {InputLabel(label, isMandatory)}
      <div>
        <div className={classnames('d-inline-block', { 'bg-color-grey': disabled })}>
          <label className="d-flex align-items-center form-elem dark--text padding--none">
            <DatePicker
              onDateChange={handleOnChange}
              placeholderText={placeholderText}
              showMonthDropdown={true}
              showYearDropdown={true}
              disabled={disabled}
              date={value ? moment(value) : null}
              dateFormat={REACT_DATEPICKER_DATE_FORMAT}
              {...rest}
            />
          </label>
        </div>
      </div>
      {error && <span className="color-red">{error}</span>}
    </div>
  );
};

export default DateSelector;
